<div class="countdown">
  <div class="time" #t>{{ time }}</div>
  <svg viewBox="0 0 100 100" #svg>
    <circle r="45" cx="50" cy="50"></circle>
  </svg>
</div>
